import {
  matchAppliedStylesWithBrandStyleOnRelation,
} from 'modules/Lexical/TextRelationStyles/matchAppliedStylesWithBrandStyleOnRelation';
import * as Models from 'models';
import { hasMultipleFontWeightsOrStyles } from './hasMultipleFontWeightsOrStyles';
import { matchAppliedStylesWithBrandStyleOnComponent } from './matchAppliedStylesWithBrandStyleOnComponent';

export const matchAppliedStylesWithBrandStyle = (
  textRelationStyles: Models.TextRelationStyles,
  textComponent: Models.TextComponent,
  brandStyle: Models.BrandStyleMap,
  colors: Models.BrandColorsList,
  fonts: Models.BrandFontsList,
): [Models.TextRelationStyles, Models.TextComponent] => {
  // multiple style indicates changed inline style, therefore brandStyleChanged flag should be true
  const hasMultipleStyles = hasMultipleFontWeightsOrStyles(textComponent.lexicalState ?? '');

  const [updatedTextRelationStyles, brandStyleChangedRelation] = matchAppliedStylesWithBrandStyleOnRelation(
    textRelationStyles, brandStyle, colors, fonts,
  );

  const [updatedTextComponent, brandStyleChangedComponent] = matchAppliedStylesWithBrandStyleOnComponent(
    textComponent, brandStyle, colors, fonts,
  );

  return [
    {
      ...updatedTextRelationStyles,
      brandStyleChanged: brandStyleChangedRelation || brandStyleChangedComponent || hasMultipleStyles,
      brandStyleId: brandStyle.get('id'),
    },
    updatedTextComponent,
  ];
};

